import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=be2d629e&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=be2d629e&lang=scss"
import style1 from "./Notifications.vue?vue&type=style&index=1&id=be2d629e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2d629e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be2d629e')) {
      api.createRecord('be2d629e', component.options)
    } else {
      api.reload('be2d629e', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=be2d629e&scoped=true", function () {
      api.rerender('be2d629e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Header/Notifications.vue"
export default component.exports